declare var GridStack: any;

namespace Matrix.Dashboards {

    interface ParamEditorItem {
        editor: Serenity.Widget<any>;
        item: Serenity.PropertyItem;
    }

    export const recreateWidgetBodyTrigger = "recreatewidgetbody";

    const prmToolbarClass = "param-bindings-toolbar";

    @Serenity.Decorators.registerClass()
    export class DashboardViewer extends Serenity.Widget<any> {

        protected widgetTypeLookup: Q.Lookup<WidgetTypeItem>;
        protected gridStack: any;
        protected nextId: number = 0;
        protected nextEditorId: number = 0;
        protected loadedItems: DashboardItem[];
        protected paramBindingValues: Q.Dictionary<object> = {};
        protected toolbar: JQuery;

        constructor(container: JQuery, opt: any) {
            super(container, opt);

            container.addClass('dashboard-container dashboard-viewing');

            $(this.getTemplate()).appendTo(container);

            this.gridStack = GridStack.init(this.getGridStackOptions(),
                '#' + this.uniqueName + "_DashboardItems");

            Q.getLookupAsync<WidgetTypeItem>("Dashboards.WidgetType").then(lookup => {
                this.widgetTypeLookup = lookup;
                this.widgetTypesLoaded();
            });

            this.element.on('click', '.s-WidgetExpandCollapse', e => {
                this.toggleWidget($(e.target).closest('.grid-stack-item'));
            });
        }

        protected widgetTypesLoaded() {
            this.renderLoadedItems();
        }

        protected getGridStackOptions(): any {
            return {
                styleInHead: true,
                cellHeight: 75,
                staticGrid: true
            }
        }

        protected getTemplate() {
            return `<div class="grid-stack" id="${this.uniqueName}_DashboardItems">
</div>`;
        }

        renderWidgetOn(el: JQuery, widgetTypeKey: string, options: any) {

            var container = el.children('.grid-stack-item-content').html('');

            var widgetType = this.getWidgetType(widgetTypeKey);
            if (!widgetType)
                return;

            this.createWidgetTitleAndBody(container, widgetType, options);
        }

        protected createWidgetTitleAndBody(container: JQuery, widgetType: any, options: any) {
            container.off(recreateWidgetBodyTrigger).on(recreateWidgetBodyTrigger, this.reCreateWidgetBody.bind(this, container, widgetType, options));
            this.initTitleAndParams(container, options);
            this.createWidgetBody(container, widgetType, options);
        }

        protected initTitleAndParams(container: JQuery, options: IWidgetOptions) {

            var paramEditors: Q.Dictionary<Q.Dictionary<ParamEditorItem>> = {};
            var paramsOnWidgetKeys = Object.keys(options).filter(x => Q.endsWith(x, paramsOnWidgetSuffix) && options[x] != null && options[x].length);
            var datasetProperties = paramsOnWidgetKeys.map(x => x.substr(0, x.length - paramsOnWidgetSuffix.length));

            var dataBindingKeys = [];
            for (var x of Object.keys(options).filter(x => Q.endsWith(x, paramBindingsSuffix) && options[x] != null)) {
                var d = options[x];
                var ks = Object.keys(d).filter(z => !Q.isEmptyOrNull(d[z]));
                if (!ks.length)
                    continue;

                var dp = x.substr(0, x.length - paramBindingsSuffix.length);
                if (datasetProperties.indexOf(dp) < 0)
                    datasetProperties.push(dp);

                for (var z of ks) {
                    var bk = d[z];
                    if (dataBindingKeys.indexOf(bk) < 0)
                        dataBindingKeys.push(bk);
                }
            }

            container.attr('data-binding-keys', !dataBindingKeys.length ? null : JSON.stringify(dataBindingKeys));

            var header = (options.Title || paramsOnWidgetKeys.length || options.TitleLinkUrl || options.Collapsible) ?
                $(`<div class="s-WidgetHeader"></div>`)
                    .appendTo(container) : null;

            if (header) {
                var titleDiv = $(`<div class="s-WidgetTitle">${Q.htmlEncode(options.Title)}</div>`).appendTo(header);
                if (options.TitleLinkUrl)
                    $(`<a class="s-WidgetTitleLink" href="${Q.attrEncode(Q.resolveUrl(options.TitleLinkUrl))}" title="more info"></a>`).appendTo(titleDiv);
            }


            for (var datasetProperty of datasetProperties) {
                var datasetCode = options[datasetProperty];
                if (datasetCode == null)
                    continue;

                DatasetService.ListParameters({
                    DatasetCode: datasetCode,
                },
                    response => {
                        if (!response.Parameters)
                            return;

                        var paramEd = paramEditors[datasetProperty] = {};
                        var paramValues = Q.extend({}, options[datasetProperty + paramValuesSuffix]) as Q.Dictionary<any>;
                        var paramsOnWidget = options[datasetProperty + paramsOnWidgetSuffix] as string[];
                        var paramBindings = options[datasetProperty + paramBindingsSuffix] as Q.Dictionary<string>;

                        for (var prm of response.Parameters) {

                            var bindingKey = paramBindings != null ? paramBindings[prm.name] : null;
                            if (bindingKey != null && this.paramBindingsOnToolbar.indexOf(bindingKey) >= 0) {
                                var prmContainer = this.element.find('.' + prmToolbarClass)
                                    .children('[data-prmkey=' + CSS.escape(bindingKey) + ']');
                                if (prmContainer.length && !prmContainer.children().length) {
                                    this.createParameterEditor(prm, prmContainer.show(),
                                        this.uniqueName + "_parambindingontoolbar_" + (++this.nextEditorId), paramBindings, paramValues);
                                }
                            }

                            if (paramsOnWidget == null || paramsOnWidget.indexOf(prm.name) < 0)
                                continue;

                            try {
                                var editor = this.createParameterEditor(prm, $('<div class="param-on-widget" />').appendTo(header),
                                    this.uniqueName + "_paramonwidget_" + (++this.nextEditorId), paramBindings, paramValues);

                                paramEd[prm.name] = <ParamEditorItem>{
                                    editor: editor,
                                    item: prm
                                };
                            }
                            catch {
                            }
                        }

                        $('.s-WidgetExpandCollapse', header).appendTo(header);
                    });
            }

            if (header && options.Collapsible)
                $(`<a class="s-WidgetExpandCollapse" href="javascript:;" title="toggle"></a>`).appendTo(header);

            (options as IWidgetOptions).__getDatasetParams = (property = "DatasetCode") => {
                var paramBindings = options[property + paramBindingsSuffix] ?? {};
                var params: { [key: string]: any } = Q.extend({}, options[property + paramValuesSuffix]);

                var rangeParams = getRangeParams(params);

                // override param values with data from binding values if any
                for (var paramName in paramBindings) {
                    var bindingKey = paramBindings[paramName] as string;
                    if (bindingKey == null || !bindingKey.length)
                        continue;

                    if (bindingKey in this.paramBindingValues) {
                        var key = rangeParams[paramName] ?? paramName;
                        params[key] = this.paramBindingValues[bindingKey];
                    }
                }

                var paramEd = paramEditors[property];
                if (paramEd != null) {
                    for (var key in paramEd) {
                        var x = paramEd[key];

                        var getEditValue = Q.safeCast(x.editor, Serenity.IGetEditValue) as Serenity.IGetEditValue;
                        if (getEditValue != null)
                            getEditValue.getEditValue(x.item, params);
                        else
                            params[x.item.name] = Serenity.EditorUtils.getValue(x.editor);
                    }
                }

                rangeParams = getRangeParams(params);

                // set initial binding values from params
                for (var paramName in paramBindings) {
                    var bindingKey = paramBindings[paramName] as string;
                    if (bindingKey == null || !bindingKey.length)
                        continue;

                    if (!(bindingKey in this.paramBindingValues)) {
                        var key = rangeParams[paramName] ?? paramName;
                        this.paramBindingValues[bindingKey] = params[key];
                    }
                }

                for (var key in params) {
                    var idx = key.indexOf('::');
                    if (idx < 0)
                        continue;

                    // special date range case
                    var startProp = key.substr(0, idx);
                    var endProp = key.substr(idx + 2);
                    var range = parseDateRange(params[key]);
                    params[startProp] = range?.start;
                    params[endProp] = range?.end;
                    delete params[key];
                }

                return params;
            };
        }

        protected createWidgetBody(container: JQuery, widgetType: any, options: any) {
            var body = $('<div class="s-WidgetBody" />').appendTo(container);
            new widgetType(body, options);
        }

        protected reCreateWidgetBody(container: JQuery, widgetType: any, options: any) {
            container.children('.s-WidgetBody').replaceWith('<div class="s-WidgetBody" />');
            new widgetType(container.children('.s-WidgetBody'), options);
        }

        getWidgetType(widgetTypeKey: string) {
            if (widgetTypeKey == null)
                return null;

            var widgetTypeItem = this.widgetTypeLookup.itemById[widgetTypeKey]

            if (!widgetTypeItem || !widgetTypeItem.ScriptType)
                return null;

            return Q.getType(widgetTypeItem.ScriptType) as any;
        }

        protected getValue() {
            return this.loadedItems || [];
        }

        get value(): DashboardItem[] {
            return this.getValue();
        }

        set value(val: DashboardItem[]) {
            this.gridStack.removeAll(true);
            this.nextId = 0;

            this.loadedItems = (val || []);
            this.renderLoadedItems();
        }

        protected renderLoadedItems() {
            if (!this.widgetTypeLookup)
                return;

            var val = this.loadedItems || [];

            var items = val.map((item) => {

                var h = item.LayoutH;
                if (item.WidgetOptions?.Collapsible &&
                    item.Collapsed) {
                    h = 1;
                }
                else
                    h = Math.max(item.LayoutH, minWidgetRows);

                return {
                    x: item.LayoutX,
                    y: item.LayoutY,
                    w: item.LayoutW,
                    h: h,
                    noResize: h == 1,
                    minH: h == 1 ? 1 : minWidgetRows,
                    id: 'item_' + (this.nextId++).toString()
                }
            });
                

            this.gridStack.load(items, true);

            (this.gridStack.getGridItems() as HTMLElement[]).forEach(el => {
                var $el = $(el);
                var id = $el.attr('gs-id');
                if (id == null || !Q.startsWith(id, 'item_'))
                    return;

                var item = val[Q.toId(id.substr(5))];

                var collapsed = !!(item.WidgetOptions?.Collapsible && item.Collapsed);
                if (collapsed) {
                    $el.addClass('collapsed-widget');
                    $el.attr('gs-h-org', item.LayoutH);
                }

                try {
                    this.renderWidgetOn($el, item.WidgetType, item.WidgetOptions || {});
                }
                catch {
                }
            });
        }

        toggleWidget(el: JQuery, expand?: boolean) {

            var collapsed = !!(el.hasClass('collapsed-widget'));
            expand = !!(expand ?? collapsed);
            if (!!collapsed == !expand)
                return;

            el.toggleClass('collapsed-widget', !expand);
            if (expand) {
                var orgHeight = Math.max(minWidgetRows, Q.toId(el.attr('gs-h-org')) || Q.toId(el.attr('gs-h')) || defaultWidgetRows);
                this.gridStack.update(el[0], {
                    h: orgHeight,
                    minH: minWidgetRows,
                    noResize: false
                });
                el.removeAttr('gs-h-org');
            }
            else {
                el.attr('gs-h-org', el.attr('gs-h'));
                this.gridStack.update(el[0], {
                    h: 1,
                    minH: 1,
                    noResize: true
                });
            }
        }

        protected paramEditorChange(prm: Serenity.PropertyItem, editor: Serenity.Widget<any>): void {

            var widgetItem = editor.element.closest('.grid-stack-item-content');
            var bindingKey = editor.element.attr('data-binding-key');
            if (bindingKey != null && bindingKey.length) {

                var bindingValue: any;

                var getEditValue = Q.safeCast(editor, Serenity.IGetEditValue) as Serenity.IGetEditValue;
                if (getEditValue != null) {
                    var obj: any = {};
                    getEditValue.getEditValue(prm, obj);
                    var rp = getRangeParams(obj);
                    var key = rp[prm.name] ?? prm.name;
                    bindingValue = obj[key];
                }
                else
                    bindingValue = Serenity.EditorUtils.getValue(editor);

                this.paramBindingValues[bindingKey] = bindingValue;

                $('.param-on-widget [data-binding-key]', this.element).each((ix, el) => {
                    if (el == editor.element[0])
                        return;

                    if ($(el).attr('data-binding-key') !== bindingKey)
                        return;

                    var ed = $(el).tryGetWidget(Serenity.Widget);
                    if (!ed)
                        return;

                    var setEditValue = Q.safeCast(ed, Serenity.ISetEditValue) as Serenity.ISetEditValue;
                    if (setEditValue != null) {
                        obj = {};
                        var prm = { name: '_' };
                        obj[getRangeFieldFor(ed, prm)] = bindingValue;
                        setEditValue.setEditValue(obj, prm);
                    }
                    else
                        Serenity.EditorUtils.setValue(editor, bindingValue);
                });

                widgetItem.triggerHandler(recreateWidgetBodyTrigger);

                $('.grid-stack-item-content[data-binding-keys]', this.element).not(widgetItem).each((ix, el) => {
                    var val = JSON.parse($(el).attr('data-binding-keys') ?? '[]');
                    if (val.indexOf(bindingKey) >= 0)
                        $(el).triggerHandler(recreateWidgetBodyTrigger);
                });
            }
            else
                widgetItem.triggerHandler(recreateWidgetBodyTrigger);
        }

        private _paramBindingsOnToolbar: string[] = [];

        public get paramBindingsOnToolbar() {
            return this._paramBindingsOnToolbar;
        }

        public set paramBindingsOnToolbar(value: string[]) {
            this._paramBindingsOnToolbar = (value ?? []).filter((v, i, a) => a.indexOf(v) === i);
            this.reinitParamBindingsOnToolbar();
        }

        protected reinitParamBindingsOnToolbar() {
            var toolbar = this.element.find('.' + prmToolbarClass);
            if (!toolbar.length) {
                toolbar = $(`<div class="${prmToolbarClass}"></div>`)
                    .insertBefore($('#' + this.uniqueName + "_DashboardItems"));
            }
            else 
                toolbar.empty();

            if (!this._paramBindingsOnToolbar.length)
                toolbar.hide();
            else {
                for (var x of this._paramBindingsOnToolbar) {
                    $(`<div class="param-on-widget param-binding-on-toolbar" data-prmkey="${Q.attrEncode(x)}"></div>`)
                        .hide()
                        .appendTo(toolbar);
                }
            }
        }

        protected createParameterEditor(prm: Serenity.PropertyItem, container: JQuery, id: string,
            paramBindings: Q.Dictionary<string>, paramValues: Q.Dictionary<any>) {
            var editorType = Serenity.EditorTypeRegistry.get(prm.editorType ?? 'String');

            var element = Serenity.Widget.elementFor(editorType).addClass('editor')
                .attr('id', id)
                .attr('placeholder', prm.title ?? prm.name)
                .appendTo(container);

            var editor = new editorType(element, Q.extend({}, prm.editorParams));
            editor.initialize();

            var bindingKey: string = paramBindings != null ? paramBindings[prm.name] : null;
            if (bindingKey != null && bindingKey.length) {
                editor.element.attr('data-binding-key', bindingKey);

                if (bindingKey in this.paramBindingValues) {
                    paramValues[getRangeFieldFor(editor, prm)] = this.paramBindingValues[bindingKey];
                }
            }

            var setEditValue = Q.safeCast(editor, Serenity.ISetEditValue) as Serenity.ISetEditValue;
            if (setEditValue != null)
                setEditValue.setEditValue(paramValues, prm);
            else
                Serenity.EditorUtils.setValue(editor, paramValues[prm.name]);

            var changeHandler = this.paramEditorChange.bind(this, prm, editor, bindingKey);
            editor[Q.isInstanceOfType(editor, Serenity.Select2Editor) ? "changeSelect2" : "change"](changeHandler);

            return editor;
        }
    }

    function getRangeParams(params: any): Q.Dictionary<string> {
        var rangeParams: Q.Dictionary<string> = {};
        for (var key in params) {
            var idx = key.indexOf('::');
            if (idx >= 0) {
                var startProp = key.substr(0, idx);
                if (startProp && !(startProp in rangeParams))
                    rangeParams[startProp] = key;
            }
        }
        return rangeParams;
    }

    function getRangeFieldFor(editor: Serenity.Widget<any>, prm: Serenity.PropertyItem) {
        var getEditValue = Q.safeCast(editor, Serenity.IGetEditValue) as Serenity.IGetEditValue;
        if (getEditValue != null) {
            var obj = {};
            getEditValue.getEditValue(prm, obj);
            var rp = getRangeParams(obj);
            var name = Object.keys(rp)[0];
            return name == null ? prm.name : (rp[name] ?? prm.name);
        }
        return prm.name;
    }
}